function Services(){
    return(
        <>
        <div className="services">
            <div className="continer">
                <h4>Services
</h4>
                <p>Excllent Medical Services
</p>

            </div>


<div className="content py-5">
  <div className="container">
    <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
      
      <div className="col">
        <div className="service-card text-center p-4 shadow-sm rounded">
          <i className="fas fa-ambulance fa-3x text-primary mb-3"></i>
          <h5>Emergency Care</h5>
          <p>24/7 emergency medical services with rapid response team.</p>
        </div>
      </div>

      <div className="col">
        <div className="service-card text-center p-4 shadow-sm rounded">
          <i className="fas fa-stethoscope fa-3x text-primary mb-3"></i>
          
           <h5>Operation & Surgery</h5>
          <p>Advanced surgical procedures with experienced specialists.</p>
        </div>
      </div>

      <div className="col">
        <div className="service-card text-center p-4 shadow-sm rounded">
          <i className="fas fa-stethoscope fa-3x text-primary mb-3"></i>
          <h5>Outdoor Checkup</h5>
          <p>Comprehensive outpatient consultations and examinations.</p>
        </div>
      </div>

      <div className="col">
        <div className="service-card text-center p-4 shadow-sm rounded">
          <i className="fas fa-ambulance fa-3x text-primary mb-3"></i>
          <h5>Ambulance Service</h5>
          <p>Fully equipped ambulances available round the clock.</p>
        </div>
      </div>

      <div className="col">
        <div className="service-card text-center p-4 shadow-sm rounded">
          <i className="fas fa-prescription-bottle-alt fa-3x text-primary mb-3"></i>
          <h5>Medicine & Pharmacy</h5>
          <p>Complete pharmacy services with genuine medications.</p>
        </div>
      </div>

      <div className="col">
        <div className="service-card text-center p-4 shadow-sm rounded">
          <i className="fas fa-vial fa-3x text-primary mb-3"></i>
          <h5>Blood Testing</h5>
          <p>Fast and accurate laboratory blood analysis services.</p>
        </div>
      </div>

    </div>
  </div>
</div>
        </div>
        </>
    )
}
export default Services